import { RingLoader } from '@magicdoorinc/ui';
import { createEffect, createMemo, createSignal, Show } from 'solid-js';
import type { JSX } from 'solid-js';

type SwitchProps = {
  name?: string;
  disabled?: boolean;
  values?: any[];
  checked?: any;
  onChange?: (v: any) => void;
  style?: JSX.CSSProperties;
  enableLoading?: boolean;
};
const InputSwitch = (props: SwitchProps) => {
  const [checked, setChecked] = createSignal<any>(undefined);
  const [loading, setLoading] = createSignal<boolean>(false);

  const values = createMemo<any[]>(() => props.values || [true, false]);

  const toggleSwitch = async () => {
    if (props.disabled) {
      return;
    }
    setLoading(true);
    const flag = checked();
    const v = !flag ? values()[0] : values()[1];
    let result: any;
    if (props.onChange) {
      result = await props.onChange(v);
    }
    setChecked(result ?? v);
    setLoading(false);
  };

  createEffect(() => {
    setChecked(props.checked);
  });
  return (
    <div
      class="relative flex h-6 w-11 shrink-0 cursor-pointer select-none rounded-full transition-colors"
      classList={{
        'cursor-not-allowed': props.disabled,
        'bg-primary': checked(),
        'bg-[#EDF2F7]': !checked(),
      }}
      style={props.style}
      tabIndex="0"
      onClick={toggleSwitch}>
      <span
        class="absolute m-0.5 flex size-5 items-center justify-center rounded-full bg-white transition-all"
        classList={{
          'left-0': !checked(),
          'left-5': checked(),
        }}>
        <Show when={loading() && props.enableLoading}>
          <RingLoader size={16} color="#7717DD" />
        </Show>
      </span>
      <input name={props.name} type="hidden" value={checked() ? values()[0] : values()[1]} />
    </div>
  );
};

export default InputSwitch;
